// Legacy custom URI scheme kept working in parallel during the migration to
// OS-verified HTTPS deep links (iOS Universal Links / Android App Links).
export const SCENE_PLUS_DEEP_LINK = 'shell-app-america-auth://scene-login';

// Time to wait for the OS to hand control to the Shell App before falling back
// to the relevant app store (per acceptance criteria: 2 seconds).
export const FALLBACK_TIMEOUT_MS = 2000;

// Shell App Americas ("Shell: Fuel, Charge & More") store listings, used only by
// the Unhappy-Path fallback when the app is not installed.
export const IOS_STORE_URL = 'https://apps.apple.com/app/id1410234033';
export const ANDROID_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.shell.sitibv.motorist.america';

export const OS_IOS = 'ios';
export const OS_ANDROID = 'android';
export const OS_UNKNOWN = 'unknown';
